import { render, staticRenderFns } from "./LoginBase.vue?vue&type=template&id=28bdca39&scoped=true"
import script from "./LoginBase.vue?vue&type=script&lang=js"
export * from "./LoginBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bdca39",
  null
  
)

export default component.exports